import "@jpj/ui/reset.css";
import "@jpj/ui/components.css";
import "./styles/theme.css";
import "./styles/game.css";

import { $, hideOverlay, runTeaser } from "@jpj/game-shell";
import { warmUpHighs } from "@jpjj/solver-core";
import { Stage } from "./three/scene";
import { initFlow, loadIsland, nextFromOverlay, retryIsland, restartRun, submitIsland, unloadIsland } from "./game/flow";
import { initInteraction, quayTap, rotateHeld } from "./game/interaction";
import { state } from "./game/state";
import { initReveal, nextCompare, resetReveal, viewOpt, viewYou } from "./reveal/reveal";
import { closeLearn, openLearn, stepLearn } from "./reveal/learn";

const stage = new Stage($("scene"));
initFlow(stage, quayTap);
initInteraction(stage);
initReveal(stage);

/* keep the whole deck tappable: the 3D viewport ends where the quay dock
   begins (the dock's height varies with viewport and phase) */
const dockbar = document.querySelector(".dockbar") as HTMLElement;
const fitScene = () => {
  const h = document.body.classList.contains("reveal-on") ? 0 : dockbar.offsetHeight;
  $("scene").style.bottom = h + "px";
  stage.resize();
};
new ResizeObserver(fitScene).observe(dockbar);
new MutationObserver(fitScene).observe(document.body, { attributes: true, attributeFilter: ["class"] });
fitScene();

/* ---------------- buttons ---------------- */

const beginGame = (): void => {
  hideOverlay("introOverlay");
  loadIsland(0);
  // wake the solver worker + WASM during play so the reveal solves feel instant
  warmUpHighs();
};
$("beginBtn").addEventListener("click", beginGame);

$("resetBtn").addEventListener("click", () => { if (state.phase === "play") unloadIsland(); });
$("rotateBtn").addEventListener("click", rotateHeld);
$("sailBtn").addEventListener("click", submitIsland);

$("ioRetry").addEventListener("click", retryIsland);
$("ioNext").addEventListener("click", nextFromOverlay);

$("cmpNext").addEventListener("click", nextCompare);
$("viewYouBtn").addEventListener("click", viewYou);
$("viewOptBtn").addEventListener("click", viewOpt);

$("learnBtn").addEventListener("click", openLearn);
$("learnBack").addEventListener("click", closeLearn);
$("lPrev").addEventListener("click", () => stepLearn(-1));
$("lNext").addEventListener("click", () => stepLearn(1));

$("againBtn").addEventListener("click", () => { resetReveal(); restartRun(); });

/* the 3D ship renders behind the intro; show island 1's silhouette */
// the title scene stays up until the player picks "How to Play" or "Start"
runTeaser({ onStart: beginGame });
stage.setIsland(3, 3, 2);

/* test hook: lets the headless verification drive real pointer events */
(window as unknown as { __pd: object }).__pd = {
  state,
  cellToScreen: (x: number, y: number, z = 0) => stage.cellToScreen(x, y, z),
  pickCell: (cx: number, cy: number) => stage.pickCell(cx, cy),
  pickLoot: (cx: number, cy: number) => stage.pickLoot(cx, cy),
};
